import DebtList from './DebtList';

export default DebtList;
